var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomCollaspe',{staticClass:"filter-collapse",attrs:{"collapse-id":'chains-collapse',"collapse-header":'Chains'}},[_c('CustomCheckbox',{attrs:{"checkbox-label":'BSC',"default-value":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }